import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Header from './components/layout/Header';
import Footer from './components/layout/Footer';
import Home from './components/home/Home';
import About from './components/about/About';
import Warranty from './components/about/Warranty';
import Contact from './components/contact/Contact';
import Neighborhoods from './components/neighborhoods/Neighborhoods';
import Neighborhood from './components/neighborhoods/Neighborhood';
import PropertyDetail from './components/neighborhoods/PropertyDetail';
import Homes from './components/homes/Homes';
import HomeDetail from './components/homes/HomeDetail';

function App() {
  return (
    <Router>
      <div className="flex flex-col min-h-screen">
        <Header />
        <main className="flex-grow">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/warranty" element={<Warranty />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/neighborhoods" element={<Neighborhoods />} />
            <Route path="/neighborhoods/:id" element={<Neighborhood />} />
            <Route path="/property/:id" element={<PropertyDetail />} />
            <Route path="/homes" element={<Homes />} />
            <Route path="/homes/:id" element={<HomeDetail />} />
          </Routes>
        </main>
        <Footer />
    </div>
    </Router>
  );
}

export default App;
